import { combineReducers } from '@reduxjs/toolkit';

import commonReducer from './slice';
import authReducer from '../modules/auth/stores/slice';
import companyReducer from '../modules/companies/stores/slice';
import locationReducer from '../modules/locations/stores/slice';
import riderReducer from '../modules/riders/stores/slice';
import vehicleReducer from '../modules/vehicles/stores/slice';
import userReducer from '../modules/users/store/slice';
import orderReducer from '../modules/orders/store/slice';
import pricingReducer from '../modules/pricing/stores/slice';
import routePlanReducer from '../modules/route-plans/stores/slice';
import routePlanRiderReducer from '../modules/route-plans-riders/stores/slice';
import routePlanOrderReducer from '../modules/route-plans-orders/stores/slice';
import webhookReducer from '../modules/webhooks/stores/slice';
import analyticsReducer from '../modules/analytics/stores/slice';
// import dashboardReducer from '../modules/dashboard/stores/slice';
import deliveryAreaReducer from '../modules/delivery-areas/stores/slice';
import settingReducer from '../modules/settings/store/slice';

import featureFlagReducer from '../modules/feature-flags/stores/slice';
import deliveryAreaLocationReducer from '../modules/delivery-area-locations/stores/slice';
import offScheduleReducer from '../modules/off-schedules/stores/slice';
import traceLogReducer from '../modules/trace-log/stores/slice';
import carriersReducer from '../modules/carriers/stores/slice';
import issuesReducer from '../modules/issues/stores/slice';
import providerIntegrationReducer from '../modules/provider-integrations/store/slice';
import carrierRuleReducer from '../modules/carrier-rules/store/slice';
import claimReducer from '../modules/claims/stores/slice';
import sustainabilityReducer from '../modules/sustainability/stores/slice';

const appReducer = combineReducers({
  common: commonReducer,
  auth: authReducer,
  company: companyReducer,
  location: locationReducer,
  rider: riderReducer,
  vehicle: vehicleReducer,
  pricing: pricingReducer,
  user: userReducer,
  order: orderReducer,
  setting: settingReducer,
  offSchedule: offScheduleReducer,
  traceLogs: traceLogReducer,
  featureFlags: featureFlagReducer,
  routePlan: routePlanReducer,
  routePlanRider: routePlanRiderReducer,
  routePlanOrder: routePlanOrderReducer,
  webhooks: webhookReducer,
  analytics: analyticsReducer,
  // dashboard: dashboardReducer,
  deliveryAreas: deliveryAreaReducer,
  deliveryAreaLocations: deliveryAreaLocationReducer,
  carriers: carriersReducer,
  issues: issuesReducer,
  providerIntegration: providerIntegrationReducer,
  carrierRules: carrierRuleReducer,
  claim: claimReducer,
  sustainability: sustainabilityReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
